// Free school-year Premium trial, claimed in place by MathPromoBanner, and redeemable at
// /redeem?code=MATHFREE27. The banner's share flow hands out a referral link instead — except
// where there is no referral program to grant the referee anything, which the banner decides
// before offering the flow at all: the campaign key below absent from
// referral-program-configuration.
export const MATH_PROMO_CODE = 'MATHFREE27';

// The campaign the banner's share flow belongs to, mirrored from referral_controller's
// KEY_BTS_2026_MATH. An operator points it at a program through the
// referral-program-configuration flag, so a key with no entry there is a campaign that isn't
// running: the banner falls back to copying the redeem link above, and never offers the
// share flow. POST /referral/invites addresses the same campaign by this key to pick the
// invite email's template.
export const MATH_REFERRAL_PROGRAM_KEY = 'bts_2026_math';

// The surface name POST /referral/enroll maps to this campaign (referral.py's
// ENROLMENT_KEY_BY_SURFACE). Naming it is what actually assigns a teacher to
// bts_2026_math — and unlike the September Scramble, nothing else does: the
// scramble enrols every account on any /user read, this campaign enrols nobody.
// So a share ask against this key has to enrol before it asks.
export const MATH_ENROLMENT_SURFACE = 'math_promo';
